import React, { useState } from "react";
import Commentaires from "./Commentaires";
import Paiements from "./Paiements";
import GeneralInfoNew from "./GeneralInfoNew";
import Favorites from "../../Common/Favorites/Favorites";

function ModifyOrderContent({
  activeTab,
  setActiveTab,
  formData,
  setFormData,
  setcommandesTabUpdated,
  commandesTabUpdated,
  deletedPackings,
  setdeletedPackings,
  order,
}) {
  const [scrollableComment, setScrollableComment] = useState();
  switch (activeTab) {
    case "General information":
      return (
        <GeneralInfoNew formData={formData} setFormData={setFormData} />
        // <GeneralInfo
        //   formData={formData}
        //   setFormData={setFormData}
        //   order={order}
        // />
      );
    case "Comments":
      return (
        <Commentaires
          scrollableComment={scrollableComment}
          setScrollableComment={setScrollableComment}
        />
      );
    case "Payments":
      return <Paiements formData={formData} setFormData={setFormData} />;
    case "Favorites":
      return (
        <Favorites
          view="ORDER"
          setActiveTab={setActiveTab}
          setScrollableComment={setScrollableComment}
        />
      );
    default:
      return <GeneralInfoNew formData={formData} setFormData={setFormData} />;
  }
}

export default ModifyOrderContent;
